import React from "react";
import {
  RichUtils,
  KeyBindingUtil,
  EditorState,
  CompositeDecorator,
} from "draft-js";

import Link from "../Link";

export const linkStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

const addLinkPluginPlugin = {
  keyBindingFn(event, { getEditorState }) {
    const editorState = getEditorState();
    const selection = editorState.getSelection();
    if (selection.isCollapsed()) {
      return;
    }
    if (KeyBindingUtil.hasCommandModifier(event) && event.which === 75) {
      return "add-link";
    }
  },

  handleKeyCommand(command, editorState, timestamp, { setEditorState }) {
    if (command !== "add-link") {
      return false;
    }

    let link = window.prompt("Enter the URL below:");
    const selection = editorState.getSelection();

    if (link === "") {
      setEditorState(RichUtils.toggleLink(editorState, selection, null));
      return true;
    }

    if (!link) {
      return false;
    }

    const isPopup = window.confirm('Is this a popup link? (target="_blank")');

    const validAbsoluteLink =
      /(http|https):\/\/www\.[a-zA-Z]+\.[a-zA-Z]+|www\.[a-zA-Z]+\.[a-zA-Z]+|[a-zA-Z]+\.[a-z]+/;
    const validRelativeLink = /^\//;

    if (!validAbsoluteLink.test(link) && !validRelativeLink.test(link)) {
      // add a forward slash for relative links in case the user forgot
      // this helps to prevent unpredictable cross browser behavior in interpreting relative links
      link = `/${link}`;
    }

    const content = editorState.getCurrentContent();
    const contentWithEntity = content.createEntity("LINK", "MUTABLE", {
      url: link,
      target: isPopup ? "_blank" : null,
    });
    const newEditorState = EditorState.push(
      editorState,
      contentWithEntity,
      "create-entity"
    );
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey));
    return true;
  },

  decorators: [
    {
      strategy: linkStrategy,
      component: Link,
    },
  ],
};

export default addLinkPluginPlugin;
